import { useIntl } from 'react-intl'
import { Grid, IconButton } from '@mui/material'

import { USER_CHALLENGE_DEEP_LINK_BASE_URL } from 'config'
import FormSectionContainer from 'components/layout/FormSectionContainer'
import InputField from 'components/form/InputField'

import { UseFormReturn } from 'react-hook-form'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { sendErrorNotification, sendSuccessNotification } from 'utils/notifications'

interface Props {
  form: UseFormReturn<any>
  challenge: Challenge
}

export default function ChallengeReadOnlyPhase2({ form, challenge }: Props): JSX.Element {
  const intl = useIntl()
  const { register } = form

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${USER_CHALLENGE_DEEP_LINK_BASE_URL}/${challenge.token}` || '')
      sendSuccessNotification('Deeplink Copied')
    } catch {
      sendErrorNotification('Copy was not succesful')
    }
  }

  return (
    <FormSectionContainer>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <h2>{intl.formatMessage({ id: 'strings.visibilityTargeting' })}</h2>
        </Grid>
        <Grid item xs={12}>
          <Grid container gap={'6px'}>
            <Grid item xs={7}>
              <InputField
                register={register}
                name="deepLink"
                type="text"
                label={intl.formatMessage({ id: 'strings.deepLinkUrl' })}
                outlined
                placeholder={intl.formatMessage({ id: 'strings.deepLink' })}
                value={
                  challenge?.token && challenge.token !== '-1'
                    ? `${USER_CHALLENGE_DEEP_LINK_BASE_URL}/${challenge.token}`
                    : ''
                }
                disabled
              />
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
              <IconButton onClick={handleCopy}>
                <ContentCopyIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </FormSectionContainer>
  )
}
